export default {
    state: {
        pendingRequests: {},
        pendingPosters: {}
    },
    getters: {
        get_loading_active: (state) => (scope) => {
            return Object.values(state.pendingRequests).includes(scope)
                || Object.values(state.pendingPosters).includes(scope)
        },
        get_pending_requests: (state) => Object.keys(state.pendingRequests).length,
        get_pending_posters: (state) => Object.keys(state.pendingPosters).length
    },
    mutations: {
        BEGIN_LOADING_REQUEST(state, { token, scope }) {
            state.pendingRequests[token] = scope
        },
        END_LOADING_REQUEST(state, token) {
            delete state.pendingRequests[token]
        },
        BEGIN_POSTER_LOADING(state, { token, scope }) {
            state.pendingPosters[token] = scope
        },
        END_POSTER_LOADING(state, token) {
            delete state.pendingPosters[token]
        }
    }
}
